interface Applications {
  [key: string]: string;
}

export const applications: Applications = {
  NPMDEMOAPP: 'NPMDEMOAPP',
  STORYBOOK: 'STORYBOOK',
  REPAIRERSEARCH: 'REPAIRERSEARCH',
  ANALYTICSLIBRARYDEMO: 'analytics library demo',
  OMNI: 'OMNI',
  PAYMYBILLDIGISME: 'PAYMYBILLDIGISME',
  DIGISME: 'DIGISME',
  BUILDERSWARRANTY: 'BUILDERSWARRANTY',
};
